window.onload = function () {

    // Close the popup when the close button is clicked
    document.getElementById('close-btn').onclick = function () {
      document.getElementById('successPopup').style.display = 'none';
    };
    
    function copyText() {
        const textInput = document.getElementById('textToCopy');
        textInput.select();
        textInput.setSelectionRange(0, 99999); // For mobile devices

        navigator.clipboard
        .writeText(textInput.value)
        .then(() => {
            document.getElementById('copyMessage').textContent = 'copied';
        })
        .catch((err) => {
            document.getElementById('copyMessage').textContent = 'Failed to copy text.';
            console.error('Error copying text: ', err);
        });
    }
  };

  function validateForm(event) {
    const mobileNumber = document.querySelector('.mobileNumber');
    const mobileErrorMessage = document.querySelector('.error-message');
    const email = document.getElementById('email').value;
    const emailError = document.getElementById('emailError');
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    // Validate Mobile Number
    if (mobileNumber.value.startsWith('0')) {
      mobileErrorMessage.textContent = 'Please do not add 0 or 91';
      mobileErrorMessage.style.display = 'block';
      event.preventDefault();
      return false;
    }

    if (mobileNumber.value.length !== 10 || isNaN(mobileNumber.value)) {
      mobileErrorMessage.textContent = 'Please enter a valid 10-digit mobile number';
      mobileErrorMessage.style.display = 'block';
      event.preventDefault();
      return false;
    } else {
      mobileErrorMessage.style.display = 'none';
    }

    // Validate Email
    if (email !== '' && !emailPattern.test(email)) {
      emailError.style.display = 'block';
      event.preventDefault();
      return false;
    } else {
      emailError.style.display = 'none';
    }

    submitForm();
    event.preventDefault(); // Prevent default form submission
    return false;
  }

  // Mobile input validation (restrict to 10 digits)
  document.querySelector('.mobileNumber').addEventListener('input', function () {
    if (this.value.length > 10) {
      this.value = this.value.slice(0, 10);
    }
  });

  // Form submission handler with API call
  function submitForm() {
    const formData = new FormData(document.getElementById('myForm'));
    const data = {
      name: formData.get('name'),
      contact: formData.get('contact'),
      email: formData.get('email'),
      url: window.location.href,
    };

    fetch('https://edudialer.ekarostats.com/api/user/create?type=main_landing', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        api_token: '8c87-48d2-8ee5-98ad8ebfeb4a',
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((result) => {
        console.log('Success:', result);
        window.location.href = 'https://eduvouchers.com/pages/pte-thankyou';
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }

  const stickyButton = document.getElementById('stickyButton');

  window.addEventListener('scroll', () => {
    if (window.scrollY > 200) {
      // show after 200px scroll
      stickyButton.classList.add('show');
    } else {
      stickyButton.classList.remove('show');
    }
  });